export const DsfHomeUserCenter =dsf.defineAsyncComponent('DsfHomeUserCenter',()=>import(/*webpackChunkName:"platform_pc_homepage"*/"./userCenter.vue"));
